export default __webpack_public_path__ + "static/media/warning--junction-with-a-side-road-perpendicular-left--g4.64bbd277.png";